import { apiClient } from "./client";
import type { LoyaltyCardDetailResponse, LoyaltyDatasetResponse } from "./types";

export async function fetchLoyaltyDataset() {
    const response = await apiClient.get<LoyaltyDatasetResponse>("/loyalty");

    return response.data;
}

export async function fetchLoyaltyCardDetail(partnerId: number) {
    const response = await apiClient.get<LoyaltyCardDetailResponse>(`/loyalty/cards/${partnerId}`);

    return response.data;
}
